<template>
	<div id="chatView">
		<!-- <div class="container">
			<div class="headerContainer">
				<div class="title">消息管理</div>
			</div>

			<div class="stateContainer">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="全部" name="first"></el-tab-pane>
					<el-tab-pane label="新招呼" name="second"></el-tab-pane>
					<el-tab-pane label="沟通中" name="third"></el-tab-pane>
				</el-tabs>
			</div>
		</div> -->
		<!-- <div class="list" v-loading="loading1">
			<div class="listContainer">
				<div v-for="(i, index) in allChatList" :key="index" style="padding: 0 10px;">
					<div class="item" v-if="i.status === tabIndex || tabIndex === 0">
						<div class="left">
							<div class="logo">
								<img :src="i.to_chat_logo || `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${i.user_id % 10}.png`"
									alt="" />
							</div>
							<div class="center">
								<div class="nameContainer">
									<div class="name" v-if="i.to_chat_name && i.to_chat_name != ''">{{ i.to_chat_name }}
									</div>
									<div class="tag" :style="log_type === 2 ? 'opacity:1' : 'opacity:0'">
										{{ i.hr_name || '求职者' }}
									</div>
								</div>
								<div class="msg">
									[{{ i.status === 1 ? '新招呼' : '沟通中' }}]&nbsp;&nbsp;{{ i.type === 1 ? i.content : i.type === 2 ? '[图片]' : i.type === 8 ? '[语音]' : i.type === 7 ? '[附件]' : i.type === 6 ? '[招生信息]' : i.type === 9 ? '[位置]' : i.type === 3 ? i.content : '您好,您与我们的岗位要求很符合,请问可以沟通下吗？' }}
								</div>
							</div>
							<div class="time">{{ i.created_at }}</div>
						</div>
						<el-button type="primary" @click="openChatFrame(i)">去沟通</el-button>
					</div>
				</div>
				<div v-if="allChatList.length === 0">
					<div style="height: 600px; padding-top: 100px">
						<el-empty :img-size="200" description="暂无聊天信息"></el-empty>
					</div>
				</div>
			</div>
		</div> -->
		<!-- <div class="paging">
      <div class="pagingLeft">
        <el-button plain @click="previousPage">上一页</el-button>
        <el-button plain @click="nextPage">下一页</el-button>
      </div>
      <el-pagination background layout="total,prev, pager, next,jumper" :page-size="pageSizes" :total="total" @current-change="currentChange" :current-page="currentpage"> </el-pagination>
    </div> -->

		<!-- <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :show-close="false" width="800px"> -->
		<div class="elDialog">
			<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
			<div class="main">
				<div class="userName">回复{{ to_chat_name }}</div>
				<div class="ans-qws-wrap" v-loading="loading" ref="scrollContainer">
					<!-- <div v-if="log_type === 2">
		                <div class="flex-h answer" v-if="isBtoC">
		                    <div class="flex1" style="width: 150px;min-width: 52px"></div>
		                    <div class="content txt" style="background: #89d961; max-width: 274px">
		                        您好,您与我们的岗位要求很符合,请问可以沟通下吗？</div>
		                    <img class="logo" :src="schoolData.logo || defaultimg" mode="" />
		                    <div class="sanj" style="border-left-color: #89d961"></div>
		                </div>
		                <div class="flex-h school" v-else>
		                    <img class="logo" v-if="to_chat_logo" :src="to_chat_logo" mode="" />
		                    <span v-else class="logo logo-text">{{ to_chat_name }}</span>
		                    <div class="content txt" style="max-width: 360px;width:274px">我对这个职位很感兴趣希望您能看看我的简历，谢谢！</div>
		                    <div style="width: 150px" class="flex1"></div>
		                    <div class="sanj"></div>
		                </div>
		            </div> -->
					<div v-for="(item, index) in newsList" :key="index">
						<div class="time-title flex-h" v-if="item.is_showtime" style="margin-bottom: 10px">
							<div style="height: 20rpx; font-size: 14px">{{ item.created_at | convertTime }}
							</div>
						</div>
						<div class="content-box" v-if="item.type === 4 && log_type === 2"
							style="cursor: pointer">
							<div>
								<div class="job-item-box" @click="goJobDetail(item)">
									<div class="item-title flex-h">
										<span class="left"
											:style="item.content.is_hurry ? 'max-width:440px' : 'max-width:460px'">{{ item.content.job_name }}</span>
										<span class="ji" v-if="item.content.is_hurry">急招</span>
										<span class="right flex1">{{ item.content.salary_k }}</span>
									</div>
									<div class="item-block flex-h">
										<span
											v-if="item.content.education">{{ item.content.education }}</span>
										<span
											v-if="item.content.industry">{{ item.content.industry }}</span>
									</div>
									<div class="company-name flex-h">
										<div v-if="log_type === 2">
											<img class="logo" :src="schoolData.logo || defaultimg"
												mode="" />
											<!-- v-if="schoolData.logo"
									<span v-else
										class="logo logo-text">{{ schoolData.company_name.substring(0, 1) }}</span> -->
										</div>
										<img class="logo" v-else :src="schoolData.base_info.badge"
											mode="" />
					
										<span>{{ item.content.company_name }}
											{{ item.content.scale }}</span>
										<span class="flex1"></span>
									</div>
								</div>
							</div>
						</div>
					
					
						<div v-if="item.source === 2" @mouseenter="hoverIndex = index"
							@mouseleave="hoverIndex = null">
							<div class="" v-if="item.is_recall!=1">
							<div class="flex-h answer" style="margin-bottom: 0;"
								v-if="item.type === 1||item.type>10">
								<div class="flex1" style="width: 150px; min-width: 52px"></div>
								<div class="content txt" style="background: #89d961; max-width: 458px">
									{{ item.content }}
								</div>
								<div v-if="log_type === 2">
									<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
									<!-- v-if="schoolData.logo"
							<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
								</div>
								<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
								<div class="sanj" style="border-left-color: #89d961"></div>
							</div>
					
							<div v-if="item.type === 2">
								<div class="flex-h answer" style="margin-bottom: 0;"
									v-for="i in item.url_list" :key="i">
									<div class="flex1" style="width: 150px; min-width: 52px"></div>
									<div class="content txt"
										style="max-width: 458px; background: none; padding-right: 0">
										<img @click="openImg(i)"
											style="max-width: 458px; width: 100px; border-radius: 6px"
											:src="i" mode="widthFix" />
									</div>
									<div v-if="log_type === 2">
										<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
										<!-- v-if="schoolData.logo" -->
										<!-- <span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
									</div>
									<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
									<div class="sanj" style="border-left-color: #89d961; opacity: 0"></div>
								</div>
							</div>
							<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 3">
								<div class="flex1" style="width: 150px"></div>
								<div class="flex-h content"
									style="background: #fff; max-width: 274px; min-width: 204px; padding: 10px 20px; align-items: stretch"
									@click="openPdf(item)">
									<div class="felx1" style="max-width: 274px; min-width: 204px">
										<div class="txt" style="padding-bottom: 10px; padding-top: 10px">
											{{ item.file_name }}
										</div>
										<div class="size-txt">
											{{ item.file_size || '' }}
										</div>
									</div>
									<img style="width: 80px; height: 80px; margin-left: 5px"
										:src="item.url.indexOf('pdf') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/ltvxmtpuavbklbzw.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/u6tvmnyq2zcec6cs.png'"
										mode="" />
								</div>
					
								<div v-if="log_type === 2">
									<!-- v-if="schoolData.logo" -->
									<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
									<!-- <span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
								</div>
								<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
								<div class="sanj" style="border-left-color: #fff"></div>
							</div>
							<div v-if="item.type === 5">
								<div class="flex-h answer"
									style="font-size: 28px; color: #999;margin-bottom: 0;">请求交换微信已发送
								</div>
							</div>
							<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 6">
								<div class="flex1" style="width: 150px"></div>
								<div class="content txt" style="background: #89d961; max-width: 458px">
									<div class="content-school-box">
										<div class="school-title">
											{{ item.content.schoolName }}
										</div>
										<div class="flex-h school-desc">
											<span class="l1">学校地址：</span>
											<span class="l2 flex1">{{ item.content.address }}</span>
										</div>
										<div class="flex-h school-desc">
											<span class="l1">{{ log_type === 1 ? '研招' : '学校' }}官网：</span>
											<span class="l2 flex1 l3"
												@click="copySite(item.content.website, `${log_type === 1 ? '研招' : '学校'}官网`)">{{ item.content.website }}</span>
										</div>
									</div>
								</div>
								<img class="logo" :src="schoolData.base_info.badge" mode="" />
								<div class="sanj" style="border-left-color: #89d961"></div>
							</div>
							<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 7">
								<div class="flex1" style="width: 150px"></div>
								<div class="content txt"
									style="background: #fff; max-width: 274px; min-width: 200px"
									@click="openPdf(item, 1)">
									<div class="file-box flex-h">
										<div class="flex1">
											<div class="f-t-1">{{ item.content[0] }}</div>
											<span class="f-t-2">{{ item.content[2] | getSize }}</span>
										</div>
										<img v-if="item.content[1]"
											style="width: 50px; height: 50px; margin-left: 5px"
											:src="item.content[1].indexOf('.pdf') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/05/01/document_pdf.png' : item.content[1].indexOf('.doc') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/05/01/document_word.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/05/01/document_x.png'"
											mode="" />
									</div>
								</div>
								<div v-if="log_type === 2">
									<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
									<!-- v-if="schoolData.logo"
							<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
								</div>
					
								<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
								<div class="sanj" style="border-left-color: #fff"></div>
							</div>
							<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 8">
								<div class="flex1" style="width: 150px"></div>
								<div class="content txt" style="background: #89d961; max-width: 300px"
									@click="playAudio(item.content.audioUrl, index)">
									<div class="audio-facade">
					
										<div class="audio-facade-bg"
											:class="audioPlayerUrl === item.content.audioUrl ? 'play-icon' : ''">
										</div>
										<div>{{ item.content.audioSize | replaceNum }}<span>"</span></div>
									</div>
									<audio :src="item.content.audioUrl" :ref="'audio' + index" controls
										style="display: none" preload="metadata">您的浏览器不支持音频播放</audio>
								</div>
								<div v-if="log_type === 2">
									<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
									<!-- v-if="schoolData.logo"
							<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
								</div>
					
								<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
								<div class="sanj" style="border-left-color: #89d961"></div>
							</div>
							<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 9">
								<div class="flex1" style="width: 150px"></div>
								<div class="content txt"
									style="max-width: 300px; background: none; padding-right: 0"
									@click="openLocation(item.content)">
									<div class="map-box">
										<span class="tt1">{{ item.content.name }} </span>
										<span class="tt2">{{ item.content.address }} </span>
									</div>
									<img style="width: 244px; border-radius: 6px; height: 96px"
										:src="`https://apis.map.qq.com/ws/staticmap/v2/?center=${item.content.lat},${item.content.lon}&zoom=10&markers=icon:https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/06/19/klosngrvnliwq5hu.png|${item.content.lat},${item.content.lon}&key=LXDBZ-76YWQ-NO55J-4XDR5-UMS3E-RDFA2&size=440*170&scale=2`"
										mode="widthFix" />
								</div>
								<div v-if="log_type === 2">
									<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
									<!-- v-if="schoolData.logo"
							<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
								</div>
					
								<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
								<div class="sanj" style="border-left-color: #ffffff"></div>
							</div>
					
							<div class="" style="height:47px;">
								<div class="revocation" v-if="item.is_recall!=1&&hoverIndex==index&&isredact(item)">
									<el-tooltip style="width:24px;height: 24px;" effect="dark" content="撤回"
										placement="top">
										<div class="item" @click="handleLongPress(item,index)">
											<img src="../img/revocation.png" alt="" />
										</div>
									</el-tooltip>
								</div>
							</div>
							</div>
							<div class="" v-else
								style="display: flex;align-items: center;justify-content: center;margin-bottom: 15px;">
								<div class=""
									style="font-size: 14px;line-height: 20px;font-weight: 500;color: #999;margin-right: 20px;">
									你撤回了一条消息
								</div>
								<div class="" v-if="isredact(item)">
									<div class="" style="font-size: 14px;font-weight: 400;color: #676b8f;"
										@click="redact(item)"
										v-if="item.type===1">
										重新编辑
									</div>
								</div>
							</div>
						</div>
					
					
					
					
					
					
					
						<div v-if="item.source === 1">
							<div class="" v-if="item.is_recall!=1">
								<div class="flex-h school" v-if="item.type === 1||item.type>10">
									<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name || to_chat_name" :user-id="item.user_id || dataObjItem.user_id" :gender="dataObjItem.gender" :size="40" />
									<!-- <span v-else class="logo logo-text">{{ item.to_chat_name }}</span> -->
									<div class="content txt" style="max-width: 274px">
										{{ item.content }}
									</div>
									<div style="width: 150px min-width: 52px" class="flex1"></div>
									<div class="sanj"></div>
								</div>
								<div class="flex-h school" v-if="item.type === 3">
									<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name || to_chat_name" :user-id="item.user_id || dataObjItem.user_id" :gender="dataObjItem.gender" :size="40" />
									<div class="flex-h content"
										style="background: #fff; max-width: 274px; min-width: 200px; padding: 10px; align-items: stretch"
										@click="openPdf(item, 0)">
										<div class="felx1" style="max-width: 274px; min-width: 200px">
											<div class="txt"
												style="padding-bottom: 10px; padding-top: 10px">
												{{ item.file_name }}
											</div>
											<div class="size-txt">
												{{ item.file_size || '' }}
											</div>
										</div>
										<img style="width: 50px; height: 50px; margin-left: 5px"
											:src="item.url.indexOf('pdf') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/ltvxmtpuavbklbzw.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/u6tvmnyq2zcec6cs.png'"
											mode="" />
									</div>
									<div style="width: 150px" class="flex1"></div>
									<div class="sanj"></div>
								</div>
								<div v-if="item.type === 2">
									<div class="flex-h school" v-for="i in item.url_list" :key="i">
										<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name || to_chat_name" :user-id="item.user_id || dataObjItem.user_id" :gender="dataObjItem.gender" :size="40" />
										<div class="content txt"
											style="max-width: 458px; background: none; padding-left: 0">
											<img @click="openImg(i)"
												style="max-width: 458px; width: 100px; border-radius: 6px"
												:src="i" mode="widthFix" />
										</div>
										<div style="width: 150px" class="flex1"></div>
										<div class="sanj" style="opacity: 0"></div>
									</div>
								</div>
								<div v-if="item.type === 5">
									<div class="flex-h school">
										<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name || to_chat_name" :user-id="item.user_id || dataObjItem.user_id" :gender="dataObjItem.gender" :size="40" />
										<div class="content txt wechat-box" style="max-width: 458px">
											<div class="title">是否同意交换微信</div>
											<div class="wechat-btn flex-h">
												<span class="wc wl flex1"
													@click="sureWechat('抱歉我不能提供我的微信号')">否</span>
												<span class="wc flex1"
													@click="sureWechat(`我的微信号码是${item.content}`)">是</span>
											</div>
										</div>
										<div style="width: 150px" class="flex1"></div>
										<div class="sanj" style="opacity: 0"></div>
									</div>
								</div>
								<div class="flex-h school" v-if="item.type === 8">
									<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name || to_chat_name" :user-id="item.user_id || dataObjItem.user_id" :gender="dataObjItem.gender" :size="40" />
									<!-- <span v-else class="logo logo-text">{{ item.to_chat_name }}</span> -->
					
									<div class="content txt" style="max-width: 274px"
										@click="playAudio(item.content.audioUrl, index)">
										<div class="audio-facade">
											<div class="audio-facade-bg"
												:class="{ 'play-icon': audioPlayerUrl === item.content.audioUrl }">
											</div>
											<div style="font-size: 14px">
												{{ item.content.audioSize | replaceNum }}<span></span>
											</div>
										</div>
					
										<audio :src="item.content.audioUrl" :ref="'audio' + index" controls
											style="display: none" preload="metadata">您的浏览器不支持音频播放</audio>
										<!-- <audio :src="item.content.audioUrl" ref="audio" controls style="display: none"
								preload="metadata">
								您的浏览器不支持音频播放
							</audio> -->
									</div>
									<div style="width: 150px" class="flex1"></div>
									<div class="sanj"></div>
								</div>
							</div>
							<div class="" v-else
								style="display: flex;align-items: center;justify-content: center;margin-bottom: 15px;">
								<div class=""
									style="font-size: 14px;line-height: 20px;font-weight: 500;color: #999;">
									“{{item.to_chat_name}}”撤回了一条消息
								</div>
							</div>
							
						</div>
					
					
					
					</div>
					<div style="height: 30px; width: 100%"></div>
				</div>

				<div class="chartTool">
					<div class="usefulExpressions">
						<!-- <el-popover placement="top" width="485" v-model="visible"> -->
						<!-- overflow-y: scroll; -->

						<div class="usefulExpressionsBtn" @click="changeUsefulExpressions">常用语</div>
						<!-- slot="reference" -->
						<!-- </el-popover> -->
					</div>
					<div class="">
						<el-popover placement="top" width="485" v-model="visible1" @show="popoverShow">
							<div class="emjoiContainer"
								style="display: grid; grid-template-columns: repeat(8, 1fr); grid-gap: 10px 10px; height: 200px; overflow-y: scroll">
								<div class="item" @click="selectExp(item)" v-for="(item, index) in emjoi" :key="index"
									style="font-size: 20px; cursor: pointer">
									{{ item }}
								</div>
							</div>
							<img class="expression" src="../img/expression.png" alt="" slot="reference" />
						</el-popover>
					</div>
					<div class="">
						<el-popover placement="top" width="340" v-model="visible2" @show="popoverShow">
							<!-- <p>这是一段内容这是一段内容确定删除吗？</p> -->
							<div class="expression-scrool">
								<div class="send-box flex-h">
									<el-upload accept=".png, .jpg, .jpeg" class="avatar-uploader1"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess1"
										:before-upload="beforeAvatarUpload1">
										<div class="item">
											<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/06/kvkrygubqi5nqatn.png"
												mode="" />
											<span>上传照片</span>
										</div>
									</el-upload>
									<el-upload accept=".pdf,.doc,.docx,.xls,.xlsx" class="avatar-uploader1"
										:show-file-list="false"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:file-list="fileList" :on-change="handleChange">
										<div class="item">
											<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/06/kvkrygubqi5nqatn.png"
												mode="" />
											<span>上传附件</span>
										</div>
									</el-upload>
								</div>
							</div>
							<img class="more4" src="../img/more4.png" alt="" slot="reference" />
						</el-popover>
					</div>
				</div>
				<el-collapse-transition>
					<div class="emjoiContainer"
						style=" box-shadow: inset rgba(0, 0, 0, 0.1) 0px 0px 6px 0px; margin-bottom: 10px; padding: 10px 20px 10px 20px"
						v-show="usefulExpressions">
						<div class="btn" @click="addUsefulExpressions">添加</div>
						<div class="" style="display: flex;align-items: center;" v-for="(item, index) in txtlist" :key="index">
							<div class="item "  @click="userAsk(item)" :title='item'
								style="font-size: 13px; cursor: pointer; padding: 10px 10px; border-bottom: 1px solid #e5e5e5;flex: 1;"
								:style="index == txtlist.length - 1 ? 'border:none;' : ''">
								<div class="" style="display: flex;align-items: center;height: 36px;">
									<div class="two-line" style="">
										{{ item }}
									</div>
								</div>
								
							</div>
							<div class="btn" style="margin-right: 10px;" @click="editUsefulExpressions(item,index)">编辑</div>
							<div class="btn" style="background: #F56C6C;" @click="deleteUsefulExpressions(index)">删除</div>
						</div>
						
						
					</div>
				</el-collapse-transition>
				<div class="textareaContainer">
					<el-input type="textarea" style="flex: 1; margin-bottom: 10px" autosize
						placeholder="和Ta聊一聊" v-model="replyTxt" maxlength="500" v-on:keyup.enter.native="userAsk(0)">
					</el-input>
					<div class="submit" @click="userAsk(0)">
						<div class="btn">发送</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog> -->
		<!-- </el-dialog> -->
	</div>
</template>
<script>
	// import {
	// 	getAllChatList,
	// 	chatRead,
	// 	getChatList,
	// 	postChat,
	// 	schoolJobSend
	// } from '@/api/job.js'
	// import {
	// 	userAsk,
	// 	getSchoolUserQa,
	// 	getUserasklist
	// } from '@/api/studentv2'

	import {
		mapMutations,
		mapState
	} from 'vuex'
	import studentAvatar from './studentAvatar.vue'
	let emjoi = [
		'😀',
		'😃',
		'😄',
		'😁',
		'😆',
		'😅',
		'🤣',
		'😂',
		'🙂',
		'🙃',
		'😉',
		'😊',
		'😇',
		'😍',
		'😘',
		'😗',
		'😙',
		'😋',
		'😛',
		'😜',
		'😝',
		'🤑',
		'🤗',
		'🤔',
		'🤐',
		'😐',
		'😑',
		'😶',
		'😏',
		'😒',
		'🙄',
		'😬',
		'🤥',
		'😌',
		'😔',
		'😪',
		'🤤',
		'😴',
		'😷',
		'🤒',
		'🤕',
		'🤢',
		'🤧',
		'😵',
		'🤠',
		'😎',
		'🤓',
		'😕',
		'😟',
		'🙁',
		'😯',
		'😲',
		'😳',
		'😦',
		'😧',
		'😨',
		'😰',
		'😥',
		'😢',
		'😭',
		'😱',
		'😖',
		'😣',
		'😞',
		'😓',
		'😩',
		'😫',
		'😤',
		'😡',
		'😠',
		'😈',
		'👿',
		'💩',
		'💅',
		'👀',
		'👣',
		'🔪',
		'🎪',
		'🚀',
		'⏰',
		'☔',
		'🎃',
		'🎉',
		'🎁',
		'👓',
		'💊',
		'💟',
		'💯',
		'💢',
		'💥',
		'💫',
		'💦',
		'💨',
		'💣',
		'💤',
		'🀄',
		'🥀',
		'🌻',
		'🌝',
		'🌟',
		'🌜',
		'👋',
		'🤚',
		'🖐',
		'✌',
		'🤘',
		'🤙',
		'👈',
		'👉',
		'👆',
		'🖕',
		'👇',
		'☝',
		'👎',
		'✊',
		'👊',
		'🤛',
		'🤜',
		'👏',
		'👐',
		'🤝',
		'🙏',
		'💪',
		'✍',
		'🐒',
		'🐶',
		'🐕',
		'🐱',
		'🐯',
		'🍇',
		'🍈',
		'🍉',
		'🍊',
		'🍋',
		'🍌',
		'🍍',
		'🍎',
		'🍐',
		'🍑',
		'🍒',
		'🏘',
		'🚌',
		'🚕',
	]
	export default {
		name: 'chatView',
		props: {
			dataObj: {
				type: String,
				default: '',
			},
			openChartView: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				fileList: [],
				replyTxt: '',
				newsList: [],
				schoolData: {
					logo: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/04/15/luvshimm2wkcyplb.png',
					company_name: '公司',
				},
				defaultimg: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_9.png',
				isBtoC: true,
				to_chat_logo: '',
				to_chat_name: '',
				tabIndex: 0,
				allChatList: [],
				log_type: 2,
				activeName: 'first',
				emjoi: emjoi,
				total: 10,
				pageSizes: 8,
				currentPage: 1,
				currentpage: 1,

				dialogVisible: false,

				visible: false,
				visible1: false,
				visible2: false,
				textarea1: '',
				jobData: {
					job_id: 0,
					admin_id: 0,
					user_id: 0,
				},
				loading: true,
				txtlist: ['我看了您的相关经历，想和您聊聊，是否方便呢？', '您好，我想要一份您的附件简历。', '对不起，您暂不符合我们的岗位要求，期待以后有机会合作。'],
				loading1: false,
				dialogVisibleImg: false,

				dialogImageUrl: false,

				usefulExpressions: false,
				audioPlayerUrl: '',
				audioPlayerIndex: '',
				hoverIndex: null,
			}
		},
		filters: {
			convertTime(val) {
				let now = new Date()
				let year = now.getFullYear()
				let month = now.getMonth() + 1
				if (month < 10) {
					month = '0' + month
				}
				let day = now.getDate()
				if (day < 10) {
					day = '0' + day
				}
				let atime = year + '-' + month + '-' + day
				if (val) {
					if (val.substring(0, 10) === atime) {
						return val.substring(11, 16)
					} else {
						return val.substring(5, 16)
					}
				} else {
					return ''
				}
			},
			getSize(val) {
				if (val) {
					if (val * 1 > 1024 * 1024) {
						return Math.ceil((val * 1) / (1024 * 1024)) + 'M'
					} else {
						return Math.ceil((val * 1) / 1024) + 'K'
					}
				} else {
					return ''
				}
			},
			replaceNum(val) {
				if (val) {
					return Math.ceil((val * 1) / 10240)
				} else {
					return 1
				}
			},
		},
		watch: {
			openChartView(val) {
				if (val) {
					this.getChatList(this.dataObjItem.user_id, this.dataObjItem.job_id, this.dataObjItem.admin_id, this
						.dataObjItem.to_chat_name)
				}
			},
		},
		computed: {
			// oldData() {
			// 	return this.$store.getters.oldData
			// },

			...mapState({
				hasLogin: (state) => state.nextToken,
				userinfo: (state) => state.userInfo,
				schoolInfo: (state) => state.schoolData,
				adminId: (state) => state.schoolData.admin_id,
			}),

			// hasLogin() {
			// 	return this.$store.getters.nextToken
			// },
			// userinfo() {
			// 	return this.$store.getters.userinfo
			// },
			// adminId() {
			// 	return this.$store.getters.adminId
			// },
			
			isredact() {
				return (item) => {
					const messageTime = new Date(item.created_at).getTime();
					const nowTime = new Date().getTime();
					const timeDiff = nowTime - messageTime;
			
					if (timeDiff <= 2 * 60 * 1000) { // 2分钟内
						return true
					} else {
						return false
					}
				}
			
			}
		},
		mounted() {
			this.chatRead()
			this.log_type = 2
			this.getAllChatList()
			// this.getChatList()

			if (this.dataObj != '') {
				let item = JSON.parse(this.dataObj)
				this.dataObjItem = JSON.parse(this.dataObj)
				this.jobData.job_id = item.job_id
				this.jobData.admin_id = item.admin_id
				this.jobData.user_id = item.user_id
				this.to_chat_name = item.to_chat_name
				this.to_chat_logo = item.to_chat_logo

				this.needSendTIme = 1
				this.join(item.user_id)
				this.getChatList(item.user_id, item.job_id, item.admin_id, item.to_chat_name)
				this.chatSignalRead(item.user_id)
				this.dialogVisible = true
			}

			this.schoolData.logo = this.userinfo.avatar
			this.schoolData.company_name = this.userinfo.username

			let userId = this.userinfo.user_id
			let ids = userId % 26 || 0
			this.defaultimg = `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${ids}.png`
			
			this.dialogList()
		},
		methods: {
			...mapMutations(['setIslogin']),
			
			deleteUsefulExpressions(index){
				this.$confirm('确定删除该项', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let progress = JSON.parse(JSON.stringify(this.txtlist))
					progress.splice(index,1)
					this.edit(0,progress)
				}).catch(() => {
								
				});
			},
			editUsefulExpressions(item,idx){
				console.log(item)
				this.$prompt('请输入常用语', '常用语', {
				         confirmButtonText: '确定',
				         cancelButtonText: '取消',
				         inputPattern: /\S/,
				         inputErrorMessage: '内容不能为空',
						 inputValue:item,
						 closeOnClickModal:false,
				       }).then(({ value }) => {
						let progress = JSON.parse(JSON.stringify(this.txtlist))
						progress[idx] = value
				         this.edit(0,progress)
				       }).catch(() => {
				             
				       });
			},
			addUsefulExpressions(){
				 this.$prompt('请输入常用语', '常用语', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          inputPattern: /\S/,
				          inputErrorMessage: '内容不能为空',
						  closeOnClickModal:false,
				        }).then(({ value }) => {
							let progress = [value,...this.txtlist]
				          this.edit(0,progress)
				        }).catch(() => {
				              
				        });
			},
			edit(id,progress){
				this.$util.post(
					"v2/school_job/saveDialog", {
						admin_id: this.adminId,
						id:this.getDialogId,
						progress:JSON.stringify(progress)
					},
					(res) => {
						console.log(res)
						this.dialogList()
					}
				);
			},
			dialogList(){
				this.$util.post(
					"v2/school_job/getDialog", {
						admin_id: this.adminId,
					},
					(res) => {
						console.log(res)
						if (res.data&&res.data!='') {
							this.getDialogId = res.data.id
							this.txtlist = JSON.parse(res.data.progress)
						}
					}
				);
			},
			
			
			redact(item) {
				this.replyTxt += item.content
			},
			async handleLongPress(item, index) {
				const messageTime = new Date(item.created_at).getTime();
				const nowTime = new Date().getTime();
				const timeDiff = nowTime - messageTime;
			
				if (timeDiff <= 2 * 60 * 1000) { // 2分钟内
				let id = await this.getChatList1(index)
					if (item.id == '') {
						// recallChatMsg(id).then(res => {
						// 	this.newsList[index].is_recall = 1
						// })
						this.$util.post(
							'v2/school_job/recallChatMsg', {
								id: id
							},
							(res) => {
								this.sendWebSocketMessage({
									msgType:'ChatMsg',
									source: 'Front',
									message: '我撤回了一条消息',
								})
								this.newsList[index].is_recall = 1
							})
					} else {
						this.$util.post(
							'v2/school_job/recallChatMsg', {
								id: item.id
							},
							(res) => {
								this.sendWebSocketMessage({
									msgType:'ChatMsg',
									source: 'Front',
									message: '我撤回了一条消息',
								})
								this.newsList[index].is_recall = 1
							})
					}
				}
			},
			sendWebSocketMessage(message) {
				let that = this
			
				return new Promise((resolve, reject) => {
					if (!that.ws || that.ws.readyState !== 1) {
						reject('WebSocket 未连接')
						return
					}
					// console.log(message)
					that.ws.send(JSON.stringify(message))
					// that.ws.send({
					//   data: '11111'|| JSON.stringify(message),
					//   success: (rrr) => {
					//
					//     resolve()
					//   },
					//   fail: (err)=> {
					//
					//      reject(err)
					//   }
					// });
				})
			},
			getChatList1(idx) {
				let obj = {
					source: 2,
					user_id: this.jobData.user_id,
					job_id: this.jobData.job_id || 0,
					admin_id: this.jobData.admin_id || this.adminId,
				}
				return new Promise((resolve, reject) => {
					this.$util.post(
						'v2/school_job/chat_list', {
							...obj,
							log_type: this.log_type,
						},
						(res) => {
							if (res.data.length > 0) {
								resolve(res.data[idx].id)
							} else {
								resolve('')
							}
						})
				})
			},
			
			join(uid) {
				//var username = document.getElementById('uid').value;
				//var url = urlPrefix + username;
				var url = `wss://np.sx985.com/ws/imserver/${this.adminId}&3&1@${uid}&2&1`
				// urlPrefix + '888&2&1@6666&1&1';
				let that = this
				this.ws = new WebSocket(url)
				this.ws.onmessage = function(res) {
					// console.log(res)
					try {
						let datas = JSON.parse(res.data)
						// that.replay = datas.content
						// that.messages.push(datas.content)
						
					} catch (e) {
						// console.log(e)
						//TODO handle the exception
					}
			
					// this.chatRead()
					// this.getChatMsgList()
			
					that.getChatList(that.jobData.user_id, that.jobData.job_id, that.jobData.admin_id, that
						.to_chat_name)
			
			
					// var ta = document.getElementById('responseText');
					// ta.value += event.data+"\r\n";
				}
				that.ws.onopen = function(event) {
					// console.log('WebSocket 连接已打开');
					that.reconnectAttempts = 0
					//console.log(event)
					// var ta = document.getElementById('responseText');
					// ta.value += "建立 websocket 连接... \r\n";
				}
				that.ws.onerror = function(event) {
					//console.log(event)
					// var ta = document.getElementById('responseText');
					// ta.value += "建立 websocket 连接... \r\n";
				}
				that.ws.onclose = function(event) {
					// console.log(event)
					if (event.reason != '用户主动关闭') { // 非正常关闭
						that.handleReconnection();
					}
					// this.join(item.user_id)
					//console.log(event)
					// var ta = document.getElementById('responseText');
					// ta.value += "用户["+username+"] 已经离开聊天室! \r\n";
					// ta.value += "关闭 websocket 连接. \r\n";
				}
			},
			handleReconnection() {
				if (this.reconnectAttempts < this.maxReconnectAttempts) {
					this.reconnectAttempts++;
					const delay = Math.min(1000 * this.reconnectAttempts, 5000);
			
					// console.log(`尝试第 ${this.reconnectAttempts} 次重连，${delay}ms后执行`);
			
					setTimeout(() => {
						this.join(this.jobData.user_id)
					}, delay);
				} else {
					// console.error(`已达到最大重连次数 ${this.maxReconnectAttempts}`);
				}
			},
			// 退出
			exit() {
				this.ws.close(1000, '用户主动关闭');
			},
			
			popoverShow() {
				this.usefulExpressions = false
			},
			changeUsefulExpressions() {
				this.usefulExpressions = !this.usefulExpressions
			},
			handleClick(tab) {
				this.tabIndex = tab.index * 1
			},
			getChatList(userid, job_id, admin_id, to_chat_name) {
				let obj = {
					source: 2,
					user_id: userid,
					job_id: job_id || 0,
					admin_id: admin_id || this.adminId,
				}
				this.$util.post(
					'v2/school_job/chat_list', {
						...obj,
						log_type: this.log_type,
					},
					(res) => {
						if (res.data.length > 0) {
							res.data.forEach(async (item, index) => {
								if (index === 0 && item.source === 1) {
									this.isBtoC = false
								}
								if (item.type === 4) {
									try {
										item.content = JSON.parse(item.content)
										this.jobTitle = item.content.job_name
										this.jobData.job_id = item.content.job_id
									} catch (e) {
										item.content = await this.getJobCardInfo(job_id || item.job_id)
										this.jobTitle = item.content.job_name
										this.jobData.job_id = item.content.job_id
									}
								}
								if (item.type === 6) {
									item.content = JSON.parse(item.content)
								}
								if (item.type === 8 || item.type === 9) {
									item.content = JSON.parse(item.content)
								}
								if (item.type === 2) {
									item.url_list = JSON.parse(item.url)
								}
								if (item.type === 3) {
									item.file_name = item.content.split('^>')[0]
									item.file_size = item.content.split('^>')[1]
								}
								if (item.type === 1) {
									if (item.content.indexOf('我的微信号码是') > -1 || item.content.indexOf(
											'抱歉我不能提供我的微信号') > -1) {
										this.isSendWeChat = true
									}
								}
								if (item.type === 7) {
									item.content = JSON.parse(item.url)
								}
							})
							this.tel = res.data[0].to_chat_tel
							this.msg_id = res.data[0].id
							// if()
							this.sendUserId = res.data[0].user_id
							this.to_chat_logo = res.data[0].to_chat_logo ||
								`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${res.data[0].user_id % 26}.png`
							this.to_chat_email = res.data[0].to_chat_email
							this.to_chat_wechat = res.data[0].to_chat_wechat
							this.to_user_id = res.data[0].user_id
							this.to_chat_name = to_chat_name //.substring(0,1)

							this.newsList = res.data

							this.todiv = 'to_bottom'
							// setTimeout(() => {
							//   this.$nextTick(() => {
							//     this.scrollToBottom()
							//   })
							// }, 50)

							// to_chat_name
						} else {
							this.userAsk('您好,您与我们的岗位要求很符合,请问可以沟通下吗？')
						}
						// else {
						// 	let abj = {
						// 		company_name: "武汉风行传媒有限公司",
						// 		financing_situation: "",
						// 		industry: "互联网/AI",
						// 		scale: "100-499人",
						// 		job_name: "这是一个职位名称",
						// 		is_hurry: 0,
						// 		job_id: 371332,
						// 		education: "本科",
						// 		admin_id: 77160,
						// 		logo: "https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/13/jena0eeewnhawsuq.png",
						// 		user_id: 3767210
						// 	}
						// 	this.postChat(abj, 0)
						// 	this.schoolJobSend(4)
						// }
						// this.newsList = res.data
					},
					() => {
						setTimeout(() => {
							this.$nextTick(() => {
								this.scrollToBottom()
							})
							this.loading = false
						}, 500)
					}
				)

				// getChatList(obj, this.log_type)
				// 	.then((res) => {

				// 	})
				// 	.finally(() => {
				// 		setTimeout(() => {
				// 			this.$nextTick(() => {
				// 				this.scrollToBottom()
				// 			})
				// 			this.loading = false
				// 		}, 100)
				// 		// uni.hideLoading()
				// 	})
			},
			getJobCardInfo(job_id) {
				return new Promise((resolve) => {
					this.$util.post('v2/school_job/getJobInfo', { id: job_id }, (res) => {
						if (res.code === 200 && res.data) {
							const item = res.data
							if (item.salary_min > 99 || item.salary_max > 99) item.salary_k = `${item.salary_min}-${item.salary_max}/月`
							else if (item.salary_min && item.salary_max) item.salary_k = `${item.salary_min}-${item.salary_max}K`
							else if (item.salary_min) item.salary_k = `${item.salary_min}K+`
							else if (item.salary_max) item.salary_k = `${item.salary_max}K`
							else item.salary_k = '面议'
							resolve({ job_name: item.job_name, salary_k: item.salary_k, education: item.education, industry: item.industry, is_hurry: item.is_hurry, company_name: item.company_name || '', scale: item.scale || '', job_id })
						} else resolve({})
					})
				})
			},
			selectExp(item) {
				this.replyTxt = this.replyTxt + item
			},
			handleChange(file, fileList) {
				if (file.response) {
					let fileNameUrl = [file.name, file.response.data.fileUrl, file.size]
					let abj = {
						source: 2,
						user_id: this.jobData.user_id,
						url: JSON.stringify(fileNameUrl),
						type: 7,
						admin_id: this.jobData.admin_id,
						job_id: this.jobData.job_id,
						is_showtime: this.needSendTIme || 0,
					}
					let content_ary = [{
						is_read: 0,
						source: 2,
						status: 2,
						type: 7,
						url: JSON.stringify(fileNameUrl),
						content: fileNameUrl,
						is_showtime: this.needSendTIme || 0,
						created_at: this.getSimpleDate(),
					}, ]
					this.newsList = this.newsList.concat(content_ary)

					setTimeout(() => {
						this.$forceUpdate()
						this.$nextTick(() => {
							this.visible2 = false
							this.scrollToBottom()
						})
					}, 100)
					this.postChat(abj, 0)
				}
			},
			getSimpleDate() {
				let date = new Date()
				var y = date.getFullYear()
				var m = date.getMonth() + 1
				m = m < 10 ? '0' + m : m
				var d = date.getDate()
				d = d < 10 ? '0' + d : d
				var h = date.getHours()
				h = h < 10 ? '0' + h : h
				var minute = date.getMinutes()
				minute = minute < 10 ? '0' + minute : minute
				var s = date.getSeconds()
				s = s < 10 ? '0' + s : s
				return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
			},
			userAsk(txt) {
				console.log('userAsk', txt)
				// if (txt) {
				// 	this.replyTxt = txt
				// }
				this.replyTxt = this.replyTxt.trim()
				if (!this.replyTxt && !txt) {
					this.$message.error('请输入内容')
					return
				}
				// this.showEmote = false
				// this.show2 = false
				// this.show1 = false
				// this.show4 = false
				// this.todiv = 'to_bottom'
				let abj = {
					source: 2,
					user_id: this.jobData.user_id,
					content: txt || this.replyTxt,
					type: 1,
					admin_id: this.jobData.admin_id,
					job_id: this.jobData.job_id,
					is_showtime: this.needSendTIme || 0,
				}

				let content_ary = [{
					content: txt || this.replyTxt,
					is_read: 0,
					source: 2,
					status: 2,
					type: 1,
					user_id: this.jobData.user_id,
					is_showtime: this.needSendTIme || 0,
					created_at: this.getSimpleDate(),
				}, ]

				this.newsList = this.newsList.concat(content_ary)
				setTimeout(() => {
					this.$forceUpdate()
					this.$nextTick(() => {
						this.scrollToBottom()
						this.visible2 = false
					})
				}, 10)
				let t_str = txt ? 1 : 0
				this.postChat(abj, t_str)
				this.schoolJobSend(4)
				// this.getAllChatList()
				// this.visible = false
				this.usefulExpressions = false
			},
			goJobDetail(item) {
				this.$router.push({
					path: '/addPosition',
					query: {
						id: item.job_id,
					},
				})
				// this.$uniapp.goPage(`/pages/recruit/jobdetail?id=${item.job_id}`)
			},
			schoolJobSend() {
				return
				this.$util.post(
					'v2/school_job/send', {
						admin_id: this.jobData.admin_id,
						user_id: this.jobData.user_id,
					},
					(res) => {
						if (res.code == 1) {
							// localStorage.setItem("token", res.data.token);
							// this.$router.push({
							// 	path: "/main",
							// 	// query: {
							// 	//   id: 1,
							// 	// },
							// });
						}
					}
				)
				// schoolJobSend(this.jobData.admin_id, this.jobData.user_id, type).then(() => {})
			},
			scrollToBottom() {
				const container = this.$refs.scrollContainer
				if (container) {
					container.scrollTo({
						top: container.scrollHeight + 20, // 滚动到最底部
						behavior: 'smooth', // 平滑滚动
					})
				}
			},
			playAudio(audioUr, index) {
				if (this.audioPlayerIndex == '') {
					let audio = 'audio' + index
					this.$refs[audio][0].play()
					this.audioPlayerUrl = audioUr
					this.audioPlayerIndex = index
				} else {
					let audio1 = 'audio' + this.audioPlayerIndex
					this.$refs[audio1][0].play()

					let audio = 'audio' + index
					this.$refs[audio][0].pause()
					this.audioPlayerUrl = ''

					// this.audioPlayerUrl = audioUr
					this.audioPlayerIndex = ''
				}
			},
			chatRead() {
				if (!this.adminId) {
					return
				}
				let obj = {
					source: 2,
					admin_id: this.adminId,
				}
				this.$util.post(
					'v2/school_job/is_read', {
						...obj,
					},
					(res) => {
						if (res.code === 0) {
							// uni.removeTabBarBadge({
							//     index: 3
							// })
						}
					}
				)
				// chatRead(obj).then((res) => {
				// 	if (res.code === 0) {
				// 		// uni.removeTabBarBadge({
				// 		//     index: 3
				// 		// })
				// 	}
				// })
			},
			beforeAvatarUpload1() {
				this.visible2 = false
			},
			handleAvatarSuccess1(res) {
				this.lineImg = res.data.fileUrl

				if (this.lineImg) {
					let imageList = [this.lineImg]

					let abj = {
						source: 2,
						user_id: this.jobData.user_id,
						url: JSON.stringify(imageList),
						type: 2,
						admin_id: this.jobData.admin_id,
						job_id: this.jobData.job_id,
						is_showtime: this.needSendTIme || 0,
					}
					let content_ary = [{
						is_read: 0,
						source: 2,
						status: 2,
						type: 2,
						url: JSON.stringify(imageList),
						is_showtime: this.needSendTIme || 0,
						created_at: this.getSimpleDate(),
					}, ]
					this.newsList = this.newsList.concat(content_ary)
					setTimeout(() => {
						this.$forceUpdate()
						this.needSendTIme = 0
						this.$nextTick(() => {
							this.scrollToBottom()
						})
					}, 100)

					// this.visible2 = false
					this.postChat(abj, 0)
				}
			},
			postChat(abj, type) {
				if (this.needSendTIme) {
					abj.is_showtime = 1
				}

				this.$util.post(
					'v2/school_job/send', {
						admin_id: this.jobData.admin_id,
						user_id: this.jobData.user_id,
						type: 4,
					},
					() => {

					}
				)


				this.$util.post(
					'v2/school_job/chat', {
						log_type: this.log_type,
						...abj,
					},
					() => {
						this.getChatList(this.jobData.user_id, this.jobData.job_id, this.jobData.admin_id, this
							.to_chat_name)
						if (!type) {
							this.replyTxt = ''
						}
						this.lineHeight = 24
						this.showEmote = false
						this.needSendTIme = 0
					}
				)
				// postChat(abj, this.log_type).then(() => {

				// })
			},
			getAllChatList() {
				this.loading1 = true
				let obj = {
					source: 2,
					admin_id: this.adminId,
				}
				// 76862 ||

				this.$util.post(
					'v2/school_job/all_chat_list', {
						...obj,
					},
					(res) => {
						if (res.code === 0) {
							this.allChatList = res.data.map((item) => {
								let c_txt = ''
								if (item.list) {
									c_txt = item.list[0].content
									// created_at = item.list[0].created_at.substring(11, 16)
									if (item.list[0].type === 3) {
										c_txt = item.list[0].content.substring(0, item.list[0].content.indexOf(
											'^>'))
									}
								}
								return {
									to_chat_name: item.to_chat_name,
									to_chat_logo: item.to_chat_logo,
									content: c_txt,
									created_at: item.list[0].created_at,
									status: item.list[0].status,
									admin_id: item.admin_id,
									type: item.list[0].type,
									job_id: item.list[0].job_id,
									user_id: item.user_id,
									source: item.list[0].source,
								}
							})
							this.total = res.data.length
						}
						this.loading1 = false
					}
				)
				// getAllChatList(obj, this.log_type).then((res) => {
				// 	if (res.code === 0) {
				// 		this.allChatList = res.data.map((item) => {
				// 			let c_txt = ''
				// 			let created_at = ''
				// 			if (item.list) {
				// 				c_txt = item.list[0].content
				// 				created_at = item.list[0].created_at.substring(11, 16)
				// 				if (item.list[0].type === 3) {
				// 					c_txt = item.list[0].content.substring(0, item.list[0].content.indexOf(
				// 						'^>'))
				// 				}
				// 			}
				// 			return {
				// 				to_chat_name: item.to_chat_name,
				// 				to_chat_logo: item.to_chat_logo,
				// 				content: c_txt,
				// 				created_at: created_at,
				// 				status: item.list[0].status,
				// 				admin_id: item.admin_id,
				// 				type: item.list[0].type,
				// 				job_id: item.list[0].job_id,
				// 				user_id: item.user_id,
				// 				source: item.list[0].source,
				// 			}
				// 		})
				// 		this.total = res.data.length
				// 	}
				// })
			},

			currentChange(page) {
				this.currentPage = page
				// this.getEnterpriseList()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage--
				}
			},
			openImg(i) {
				// this.dialogVisibleImg = true
				// this.dialogImageUrl = i
				this.$emit('openImg', i)
			},
			openPdf(item, type) {
				if (item.type === 3) {
					this.$util.post(
						'v2/school_job/get_admin_file_config', {
							admin_id: this.adminId || 0,
						},
						(res) => {
							if (res.data && res.data.file_open_limit > 0) {
								this.$util.post(
									'v2/school_job/saveReadFileLog', {
										admin_id: item.admin_id || 0,
										company_name: this.schoolInfo.company_name || '',
										file_id: item.id || 0,
										url: item.url || '',
										user_id: item.user_id || 0,
									}
								)
								window.open(item.url, '_blank')
							} else {
								this.$message.warning('试用打开简历额度已到上限，请联系专属业务员开启更多的生源沟通！')
							}
						}
					)
				} else if (type) {
					window.open(item.content[1], '_blank')
				} else {
					window.open(item.url, '_blank')
				}
			},
			nextPage() {
				if (Math.ceil(this.total / this.pageSizes) > this.currentpage) {
					this.currentpage++
				}
			},
			selectImg() {},
			uploadPdf() {},

			// openChatFrame() {
			//   this.dialogVisible = true
			// },
			chatSignalRead(userid) {
				if (!this.adminId) {
					return
				}
				let obj = {
					admin_id: this.adminId,
					source: 2,
					user_id: userid,
					log_type: 2,
				}
				this.$util.post(
					'v2/school_job/is_read', {
						...obj,
					},
					(res) => {
						if (res.code === 0) {
							// uni.removeTabBarBadge({
							//     index: 3
							// })
						}
					}
				)
			},
			openChatFrame(item) {
				this.dialogVisible = true
				this.jobData.job_id = item.job_id
				this.jobData.admin_id = item.admin_id
				this.jobData.user_id = item.user_id
				this.to_chat_name = item.to_chat_name
				this.to_chat_logo = item.to_chat_logo
				
				this.getChatList(item.user_id, item.job_id, item.admin_id, item.to_chat_name)
				return

				// this.$uniapp.goPage(
				// 	`/pages/recruit/communicate?user_id=${item.user_id}&job_id=${item.job_id}&admin_id=${this.adminId}&userName=${item.to_chat_name}`
				// 	)
			},
			closeElDialog() {
				this.dialogVisible = false
				this.usefulExpressions = false
				this.$emit('closeDialog')

				if (this.audioPlayerIndex != '') {
					let audio1 = 'audio' + this.audioPlayerIndex
					this.$refs[audio1][0].pause()
				}
			},
			ParentOpSon() {
				if (this.audioPlayerIndex != '') {
					let audio1 = 'audio' + this.audioPlayerIndex
					this.$refs[audio1][0].pause()
				}
			},
			sureWechat() {},
		},
		components: { studentAvatar },
	}
</script>
<style>
	#chatView .el-textarea__inner {
		min-height: 75px !important;
	}

	#chatView .el-dialog {
		background: initial;
		box-shadow: initial;
		width: 465px !important;
		margin-top: 1vh !important;
	}

	#chatView .el-textarea__inner {
		resize: none !important;
		/* border: none; */
		/* background: #F4F4F4 !important; */
		height: 120px !important;
	}

	/* #messageManagement .el-dialog {
		margin: 0 auto 20px;
	} */
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.headerContainer {
			width: 100%;
			padding: 20px 0 20px 0;
			// border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			// margin-bottom: 25px;

			.title {
				margin-right: 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}

			.stateContainer {
				margin-bottom: 30px;
			}
		}

		.list {
			padding: 0 40px;
			min-height: 400px;
		}

		.listContainer {
			background: #fbfdff;
			// border: 1px solid #E5E5E5;
			// border-left: 1px solid #e5e5e5;
			// border-right: 1px solid #e5e5e5;
			// border-top: 1px solid #e5e5e5;
			width: 100%;
			min-width: 850px;
			// min-height: 600px;

			.item {
				min-width: 830px;
				border-bottom: 1px solid #e8eaf7;
				padding: 20px 30px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.left {
					flex: 1;
					display: flex;
					align-items: center;

					.logo {
						font-size: 0;
						position: relative;
						margin-right: 30px;

						img {
							width: 57px;
							height: 57px;
							border-radius: 50%;
							background: #4f8ff0;
						}

						div {
							position: absolute;
							top: 0;
							right: 0;
							padding: 0px 5px;
							background: #ff5560;
							border-radius: 50%;

							font-weight: 400;
							font-size: 14px;
							color: #ffffff;
						}
					}

					.center {
						flex: 1;
						margin-right: 50px;

						.nameContainer {
							display: flex;
							align-items: center;
							margin-bottom: 10px;

							.name {
								font-weight: 500;
								font-size: 16px;
								color: #333;
								margin-right: 17px;
							}

							.tag {
								font-weight: 400;
								font-size: 12px;
								color: #999;
								border: 1px solid rgb(239, 254, 254);
								background: rgb(239, 254, 254);
								padding: 2px 5px;
								border-radius: 5px;
							}
						}

						.msg {
							min-width: 415px;
							min-width: 413px;
							font-weight: 400;
							font-size: 14px;
							color: #333;
							word-break: break-all;
						}
					}

					.time {
						width: 160px;
						font-weight: 400;
						font-size: 14px;
						color: #333;
					}
				}

				.right {
					width: 96px;
					height: 37px;
					background: #4f8ff0;
					border-radius: 5px;

					text-align: center;
					line-height: 37px;
					font-weight: bold;
					font-size: 14px;
					color: #ffffff;
				}
			}
		}
	}

	.paging {
		width: 100%;
		padding: 20px 25px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.pagingLeft {
			display: flex;
			align-items: center;
		}
	}

	.elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 0 0 0 0;
			background: #ffffff;
			border-radius: 10px;

			.userName {
				padding: 20px 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
				text-align: left;
			}

			.msgList {
				padding: 50px 25px 0 25px;
				background: #f7f9ff;
				height: 512px;
				overflow-y: scroll;

				.item {
					margin-bottom: 40px;
				}

				.left {
					display: flex;
					align-items: flex-start;
					justify-content: flex-start;

					.userAvatar {
						font-size: 0;
						margin-right: 13px;

						img {
							width: 40px;
							height: 40px;
							border-radius: 5px;
							background: #4f8ff0;
						}
					}

					.typeContainer {
						max-width: 304px;
						background: #ffffff;
						border-radius: 10px;
						padding: 10px 15px;

						.card {
							width: 274px;

							.cardHeader {
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-bottom: 10px;

								.name {
									font-weight: 500;
									font-size: 16px;
									color: #333333;
								}

								.compensation {
									font-weight: 500;
									font-size: 16px;
									color: #fcad00;
								}
							}

							.other {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								margin-bottom: 10px;
							}

							.tags {
								display: flex;
								align-items: center;
								margin-bottom: 10px;

								.tagsItem {
									padding: 2px 3px;
									background: #f7f7f7;
									border-radius: 5px;
									font-weight: 500;
									font-size: 12px;
									color: #999;
									margin-right: 5px;
								}
							}

							.introduce {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								word-break: break-all;
							}
						}

						.text {
							font-weight: 500;
							font-size: 16px;
							color: #333;
						}

						.img {
							font-size: 0;

							img {
								max-width: 304px;
								background: #4f8ff0;
							}
						}
					}
				}

				.right {
					display: flex;
					align-items: flex-start;
					justify-content: flex-end;

					.userAvatar {
						font-size: 0;

						img {
							width: 40px;
							height: 40px;
							border-radius: 5px;
							background: #4f8ff0;
						}
					}

					.typeContainer {
						max-width: 304px;
						background: #ffffff;
						border-radius: 10px;
						padding: 10px 15px;
						margin-right: 13px;

						.card {
							width: 274px;

							.cardHeader {
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-bottom: 10px;

								.name {
									font-weight: 500;
									font-size: 16px;
									color: #333333;
								}

								.compensation {
									font-weight: 500;
									font-size: 16px;
									color: #fcad00;
								}
							}

							.other {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								margin-bottom: 10px;
							}

							.tags {
								display: flex;
								align-items: center;
								margin-bottom: 10px;

								.tagsItem {
									padding: 2px 3px;
									background: #f7f7f7;
									border-radius: 5px;
									font-weight: 500;
									font-size: 12px;
									color: #999;
								}
							}

							.introduce {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								word-break: break-all;
							}
						}

						.text {
							font-weight: 500;
							font-size: 16px;
							color: #222222;
						}

						.img {
							font-size: 0;

							img {
								max-width: 304px;
								background: #4f8ff0;
							}
						}
					}
				}
			}
		}

		.chartTool {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0 10px;

			.usefulExpressionsBtn {
				width: 66px;
				height: 30px;
				background: #dbeafe;
				border-radius: 5px;

				text-align: center;
				line-height: 30px;

				font-weight: 500;
				font-size: 14px;
				color: #4f8ff0;
				cursor: pointer;
				margin-right: 10px;

				
			}
			
			.expression {
				width: 24px;
				height: 24px;
				margin-right: 10px;
				cursor: pointer;
			}

			.more4 {
				width: 24px;
				height: 24px;
				cursor: pointer;
			}
		}

		.textareaContainer {
			// background: #F4F4F4;
			width: 100%;
			padding: 0 10px 10px 10px;
			border-radius: 0 0 10px 10px;
		}
		.emjoiContainer {
			.btn {
				width: 40px;
				height: 25px;
				background: #1e40af;
				border-radius: 5px;
			
				text-align: center;
				line-height: 25px;
			
				font-weight: 500;
				font-size: 14px;
				color: #ffffff;
				cursor: pointer;
			}
		}
		.submit {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.btn {
				width: 66px;
				height: 30px;
				background: #1e40af;
				border-radius: 5px;

				text-align: center;
				line-height: 30px;

				font-weight: 500;
				font-size: 14px;
				color: #ffffff;
				cursor: pointer;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.ans-qws-wrap {
		padding: 20px 16px 0 16px;
		box-sizing: border-box;
		background: #f7f9ff;
		height: 410px;
		overflow-y: scroll;

		.school,
		.answer {
			position: relative;
			align-items: stretch;
			margin-bottom: 20px;

			.logo {
				width: 40px;
				height: 40px;
				background: #ffffff;
				padding: 2px;
				box-sizing: border-box;
				border-radius: 5px;
			}

			.logo-text {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				background-color: blue;
				text-align: center;
				line-height: 40px;
				color: #ffffff;
				font-size: 16px;
				font-weight: 600;
				overflow: hidden;
			}

			.content {
				height: auto;
				border-radius: 5px;
				margin-left: 12px;
				position: relative;

				img {
					display: div;
					width: 100%;
				}

				.size-txt {
					padding-left: 10px;
					font-weight: 500;
					color: #999;
					font-size: 16px;
				}

				.issues-box {
					width: 426px;
					height: 264px;
					background: #ffffff;
					left: 16px;
					top: 110px;
					position: absolute;
					border-radius: 10px 10px 30px 30px;
				}

				.file-box {
					text {
						display: div;
					}

					.f-t-1 {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.f-t-2 {
						color: #999999;
						font-size: 12px;
						font-weight: 400;
						display: block;
						margin-top: 5px;
					}
				}
			}

			.txt {
				padding: 10px;
				font-size: 14px;
				line-height: 20px;
				font-weight: 500;
				color: #333;
				background: #ffffff;
				word-break: break-all;

				span {
					word-break: break-all;
					font-size: 16px;
					font-weight: 500;
					color: #222222;
					line-height: 24px;
				}

				.webs {
					color: #0572e2;
				}
			}

			.sanj {
				position: absolute;
				width: 0;
				height: 0;
				top: 10px;
				left: 32px;
				border: 12px solid transparent;
				border-right-color: #ffffff;
			}

			.sanj-img {
				position: absolute;
				width: 0;
				height: 0;
				top: 30px;
				left: 84px;
				border: 12px solid transparent;
				border-right-color: #fd8606;
			}
		}

		.answer {
			position: relative;

			.content {
				margin-right: 12px;
				margin-left: 0;
			}

			.map-box {
				width: 444px;
				height: 100px;
				background: #ffffff;
				border-top-left-radius: 6px;
				border-top-right-radius: 6px;
				padding: 10px 10px;
				box-sizing: border-box;

				span {
					display: div;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.tt1 {
					font-size: 30px;
					color: #222;
				}

				.tt2 {
					font-size: 26px;
					color: #c1c1c1;
				}
			}

			.content-school-box {
				width: 274px;
				height: auto;
				padding-bottom: 20px;
				box-sizing: border-box;

				.school-title {
					font-size: 30px;
					font-weight: bold;
					color: #333;
					margin-bottom: 20px;
				}

				.school-desc {
					margin-top: 10px;
					align-items: baseline;

					.l1 {
						width: 140px;
					}

					.l2 {
						font-size: 26px;
						font-weight: 500;
						color: #333;
					}

					.l3 {
						color: #0553f3;
					}
				}
			}

			.sanj {
				position: absolute;
				width: 0;
				height: 0;
				top: 10px;
				left: 323px;
				border: 12px solid transparent;
				border-left-color: #ffffff;
			}

			.sanj-img {
				position: absolute;
				width: 0;
				height: 0;
				top: 30px;
				left: 608px;
				border: 12px solid transparent;
				border-left-color: #fd8606;
			}
		}

		.wechat-box {
			width: 274px;
			height: 278px;
			background: #ffffff;
			border-radius: 16px;
			padding: 0;

			.title {
				width: 100%;
				height: 188px;
				line-height: 188px;
				text-align: center;
				font-size: 28px;
				font-weight: 500;
				color: #333;
			}

			.wechat-btn {
				border-top: 1px solid #f2f2f2;

				.wc {
					height: 90px;
					text-align: center;
					line-height: 90px;
					font-size: 28px;
					font-weight: 500;
					color: #333;
					line-height: 90px;
				}

				.wl {
					border-right: 1px solid #f2f2f2;
					color: #576b95;
				}
			}
		}
	}

	.content-box {
		padding: 0 20px;
		box-sizing: border-box;

		.job-item-box {
			width: 100%;
			min-height: 100px;
			height: auto;
			background: #fff;
			border-radius: 10px;
			margin-top: 20px;
			margin-bottom: 20px;
			padding: 10px 15px;
			box-sizing: border-box;

			.item-title {
				.left {
					font-size: 14px;
					font-weight: bold;
					color: #333333;
					width: auto;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.ji {
					width: 60px;
					height: 30px;
					background: #ffffff;
					border: 1px solid #ff6600;
					border-radius: 5px;
					text-align: center;
					line-height: 30px;
					font-size: 14px;
					font-weight: 500;
					color: #ff6600;
					margin-left: 6px;
				}

				.right {
					font-size: 14px;
					font-weight: bold;
					color: #ff6600;
					text-align: right;
				}
			}

			.company-name {
				// line-height: 30px;
				margin-top: 12px;

				.logo {
					width: 20px;
					height: 20px;
					border-radius: 50%;
					margin-right: 4px;
					color: #fff;
					text-align: center;
					font-size: 20px;
					line-height: 30px;
				}

				.logo-text {
					background-color: blue;
				}

				span {
					font-size: 14px;
					font-weight: 400;
					color: #999;
					width: 320px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			.item-block {
				justify-content: flex-start;
				margin-top: 10px;

				span {
					height: 22px;
					background: #f7f7f7;
					border-radius: 5px;
					padding: 0 10px;
					font-size: 12px;
					font-weight: 500;
					color: #5f5f5f;
					margin-right: 12px;
					line-height: 22px;
				}
			}
		}
	}

	.logo-text {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		background-color: blue;
		text-align: center;
		line-height: 80px;
		color: #ffffff;
		font-size: 28px;
		font-weight: 600;
		overflow: hidden;
	}

	.audio-facade {
		min-width: 20px;
		font-size: 34px;
		border-radius: 14px;
		color: #000000;
		display: flex;
	}

	.audio-facade-bg {
		background: url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/04/11/x1vp00gsvfjuhndc.png') no-repeat center;
		background-size: 20px;
		width: 40px;
	}

	.audio-facade-bg.play-icon {
		background: url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/04/11/zkiwrpfrrwwjr8jz.gif') no-repeat center;
		background-size: 30px;
	}

	.expression-scrool {
		height: 160px;
		background: #f6f6f6;

		.expression-box {
			height: 160px;
			padding: 20px 7px;
			box-sizing: border-box;
			flex-wrap: wrap;
			justify-content: flex-start;

			.item {
				width: 92px;
				font-size: 56px;
				line-height: 92px;
				height: 92px;
				text-align: center;
			}
		}

		.send-box {
			// margin-top: 50px;
			// padding-top: 30px;
			justify-content: space-between;
			padding: 20px 50px;
			box-sizing: border-box;

			.item {
				width: 80px;

				img {
					width: 80px;
					height: 80px;
					display: block;
				}

				span {
					display: block;
					text-align: center;
					font-size: 14px;
					color: #616161;
					margin-top: 6px;
				}
			}
		}
	}

	.avatar-uploader1 .avatar-uploader1 .el-upload {
		border: none;
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #eeeeee;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 15px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2d3c50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #aeaeae;
					font-weight: 500;
					font-size: 12px;
					color: #aeaeae;
					margin-right: 5px;
				}
			}
		}
	}
	
	
	
	.revocation {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 20px;
		padding-top: 3px;
		padding-right: 52px;
	
		.item {
			border-radius: 5px;
			background: #f7f9ff;
			padding: 4px;
			font-size: 0;
			cursor: pointer;
	
			img {
				width: 16px;
				height: 16px;
			}
		}
	
		.item:hover {
			background: #ccc;
		}
	
	}
</style>
